import React from 'react';

import { Modal, Stack, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import PreviewModalContent from './PreviewModalContent';
import PreviewModalFooter from './PreviewModalFooter';
import { ModalWorkoutTemplatePreviewProps } from './types';

const workoutTemplatePreviewModalBodyStyles = {
  body: {
    display: 'flex',
    flexDirection: 'column' as const,
    height: '80vh',
    maxHeight: '800px',
    padding: 0,
  },
  content: {
    display: 'flex',
    flexDirection: 'column' as const,
  },
  header: {
    borderBottom: '1px solid #e9ecef',
  },
};

const ModalWorkoutTemplatePreview = ({
  opened,
  handleClose,
  template,
  onEdit,
  showEditButton = true,
}: ModalWorkoutTemplatePreviewProps): JSX.Element => {
  const navigate = useNavigate();

  const handleEdit = (): void => {
    if (onEdit) {
      onEdit();
    } else if (template?.workoutTemplateId) {
      navigate(`/workouts/library/templates/edit/${template.workoutTemplateId}`);
    }
    handleClose();
  };

  if (!opened || !template) return <></>;

  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={3}>{template.name}</Title>}
      size='xl'
      closeButtonProps={{ 'aria-label': 'Close preview' }}
      styles={workoutTemplatePreviewModalBodyStyles}
    >
      <Stack spacing={0} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <PreviewModalContent template={template} showCoachNotes={true} />
        <PreviewModalFooter onClose={handleClose} onEdit={handleEdit} showEditButton={showEditButton} />
      </Stack>
    </Modal>
  );
};

export default ModalWorkoutTemplatePreview;
